import React from "react";
import { observer } from "mobx-react-lite";

import FormField from "../form-field/FormField";
import { dateService } from "../../services/date-service/DateService";

interface AvailableFrom {
  date: string | Date;
}

export default observer(function DisplayAvailableFrom(props: AvailableFrom) {
  return (
    <FormField
      id="available-from"
      labelKey="general.available-from"
      readOnly
      fieldValue={dateService.formatDate(props.date)}
    />
  );
});
